module.exports = __webpack_public_path__ + "img/photo-0134.d0bd2948.jpg";